(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gk-design-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDP(root) {
      if (!root || root.dataset.dpInit) return;
      root.dataset.dpInit = '1';
      var main = root.querySelector('[data-dp-main] img');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-dp-thumb]'));
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var full = t.getAttribute('data-full');
          if (full) main.src = full;
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    }
    function initAll() { document.querySelectorAll('.gk-dp').forEach(initDP); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.gk-dp');
      if (el) initDP(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gk-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      if (!root || root.dataset.gkInit) return;
      root.dataset.gkInit = '1';
      var grid = root.querySelector('[data-grid]');
      if (!grid) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('.gk-gallery__card'));
      var countEl = root.querySelector('[data-count]');
      var emptyEl = root.querySelector('[data-empty-filtered]');
      var pager = root.querySelector('[data-pager]');
      var sortSel = root.querySelector('[data-sort]');
      var perPage = parseInt(root.dataset.perPage, 10) || 18;
      var page = 1;
      var state = { event: 'ALL', theme: 'ALL', garment: 'ALL' };

      var filterToggle = root.querySelector('[data-filter-toggle]');
      if (filterToggle) {
        filterToggle.addEventListener('click', function () {
          var sidebar = filterToggle.closest('.gk-gallery__sidebar');
          var open = sidebar.classList.toggle('is-open');
          filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          var icon = filterToggle.querySelector('span');
          if (icon) icon.textContent = open ? '−' : '+';
        });
      }

      root.querySelectorAll('[data-group-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('.gk-gallery__group');
          var open = group.classList.toggle('is-open');
          var icon = btn.querySelector('.gk-gallery__group-icon');
          if (icon) icon.textContent = open ? '−' : '+';
        });
      });

      root.querySelectorAll('[data-facet-list]').forEach(function (list) {
        var facet = list.getAttribute('data-facet-list');
        list.querySelectorAll('li').forEach(function (li) {
          li.addEventListener('click', function () {
            list.querySelectorAll('li').forEach(function (x) { x.classList.remove('is-sel'); });
            li.classList.add('is-sel');
            state[facet] = li.getAttribute('data-v') || 'ALL';
            apply();
          });
        });
      });

      function vals(card, facet) {
        var raw = card.getAttribute('data-' + facet) || '';
        return raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      }
      function matches(card) {
        return ['event', 'theme', 'garment'].every(function (facet) {
          if (state[facet] === 'ALL') return true;
          return vals(card, facet).indexOf(state[facet]) !== -1;
        });
      }

      function sortCards(list) {
        var mode = sortSel ? sortSel.value : 'new';
        var sorted = list.slice();
        if (mode === 'new') {
          sorted.sort(function (a, b) { return (b.dataset.created | 0) - (a.dataset.created | 0); });
        } else if (mode === 'org') {
          sorted.sort(function (a, b) { return a.dataset.org.localeCompare(b.dataset.org); });
        } else if (mode === 'event') {
          sorted.sort(function (a, b) { return a.dataset.eventFirst.localeCompare(b.dataset.eventFirst); });
        }
        return sorted;
      }

      function apply() {
        var visible = sortCards(cards.filter(matches));
        page = 1;
        paint(visible);
      }

      function paint(visible) {
        var pages = Math.max(1, Math.ceil(visible.length / perPage));
        if (page > pages) page = pages;
        var start = (page - 1) * perPage;
        var end = start + perPage;
        var showing = visible.slice(start, end);
        cards.forEach(function (c) { c.classList.add('is-hidden'); });
        showing.forEach(function (c) { c.classList.remove('is-hidden'); grid.appendChild(c); });
        if (countEl) countEl.textContent = visible.length + ' design' + (visible.length === 1 ? '' : 's');
        if (emptyEl) emptyEl.hidden = visible.length !== 0;
        renderPager(pages, visible);
      }

      function renderPager(pages, visible) {
        pager.innerHTML = '';
        if (pages <= 1) return;
        for (var p = 1; p <= pages; p++) {
          (function (p) {
            var b = document.createElement('button');
            b.type = 'button';
            b.textContent = p;
            if (p === page) b.className = 'is-active';
            b.addEventListener('click', function () {
              page = p; paint(visible);
              var top = root.getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo({ top: top, behavior: 'smooth' });
            });
            pager.appendChild(b);
          })(p);
        }
      }

      if (sortSel) sortSel.addEventListener('change', apply);
      apply();
    }
    function initAll() {
      document.querySelectorAll('.gk-gallery').forEach(initGallery);
    }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.gk-gallery');
      if (el) initGallery(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gk-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSlideshow(root) {
      var box = root.querySelector('[data-gk-hero-slideshow]');
      if (!box || box.dataset.gkInit) return;
      box.dataset.gkInit = '1';
      var slides = box.querySelectorAll('.gk-hero__slide');
      if (slides.length < 2) return;
      var dotsWrap = box.querySelector('.gk-hero__dots');
      var idx = 0;
      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'gk-hero__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          d.addEventListener('click', function () { show(i); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }
      function show(n) {
        slides[idx].classList.remove('is-active');
        if (dots[idx]) dots[idx].classList.remove('is-active');
        idx = (n + slides.length) % slides.length;
        slides[idx].classList.add('is-active');
        if (dots[idx]) dots[idx].classList.add('is-active');
      }
      var speed = parseInt(box.dataset.autoplay, 10) || 3500;
      if (speed > 0) setInterval(function () { show(idx + 1); }, speed);
    }
    function initAll() {
      document.querySelectorAll('.gk-hero').forEach(function (el) { initHeroSlideshow(el); });
    }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.gk-hero');
      if (el) initHeroSlideshow(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
